import SlotComponent from '../../SlotComponent';
import { useCssHandles } from '../../../utils/functions';
import useResponsiveValue from '../../responsive-values/useResponsivevalue';

const CSS_HANDLES = ['gallery', 'galleryItem'];

const Gallery = ({ layouts, ...rest }: any) => {
	if (!layouts.length) return null;
	return <Container {...{ ...rest, layouts }} />;
};

const Container = ({ layouts, ...rest }: any) => {
	//n sei de onde vem o valor
	const showingFacets = true;
	//isso aqui tem q mudar no futuro caso tenha diferentes layout
	//mas por hora tá ok

	const firstLayout = layouts[0];
	const { handles }: any = useCssHandles('vtex-search-result', CSS_HANDLES, firstLayout.name);
	const { handles: handles2 }: any = useCssHandles('vtex-search-result', CSS_HANDLES, [firstLayout.name, 'normal']);
	const itemsPerRow = useResponsiveValue(firstLayout.itemsPerRow);

	const style = {
		flexBasis: `${100 / itemsPerRow}%`,
		maxWidth: `${100 / itemsPerRow}%`,
	};

	return (
		<div
			id="gallery-layout-container"
			className={`${handles.gallery} flex flex-row flex-wrap items-stretch bn ph1 na4 ${showingFacets ? 'pl9-l' : 'justify-center'}`}
		>
			{Array(itemsPerRow * 2)
				.fill(0)
				.map((_, index) => (
					<div key={`gallery-item-${index}`} style={style} className={`${handles2.galleryItem} pa4`}>
						<SlotComponent props={rest[firstLayout.component]} />
					</div>
				))}
		</div>
	);
};

export default Gallery;
